export default __webpack_public_path__ + "static/media/right-top.66ae621f.gif";